/* eslint-disable react/jsx-no-undef */
import React, { useState, useLayoutEffect } from "react";
import { NavLink, Link, Outlet } from "react-router-dom";
import Sidebar from "../../Sidebar/Sidebar";
import { FaBars } from "react-icons/fa";
import { Link as ScrollLink } from "react-scroll";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../LanguageSwitcher";
import { contacts } from "../../../utils/contact";
import "./style.css";
// console.log(contacts.tel.replaceAll("-" & " ", ""));

import logoDark from "../../../assets/icons/logo-dark1.svg";
import logo from "../../../assets/icons/logo1.svg";
import scrollToSection from "../../../utils/scrollToSection";

<ScrollLink to="Servies" smooth={true} duration={500}>
  services
</ScrollLink>;

const Navigation = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // sticky state
  const [sticky, setSticky] = useState(false);

  useLayoutEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth > 1200) {
        setSticky(window.scrollY > 160);
      } else setSticky(true);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  // window.addEventListener("scroll", stickyNavbar);

  return (
    <>
      <header>
        <div className="tp-header-area">
          <div className="tp-header-top theme-dark-bg pt-10 pb-10 d-none d-xl-block">
            <div className="tp-custom-container">
              <div className="row align-items-center">
                <div className="col-xxl-5 col-xl-4">
                  <div className="tp-header-top-info">
                    <div className="tp-header-top-info-single pr-40 mr-40 border-right-1">
                      <div className="nav-call_info tp-header-top-info-single-icon mr-10">
                        <i className="flaticon-phone-call"></i>
                        <div>
                          <span className="tp-header-top-info-single-label">
                            {t("Navigation.Phone")}
                          </span>
                          <span className="tp-header-top-info-single-content font-medium">
                            <a
                              href={`tel:${contacts.tel.replaceAll(" ", "")}`}
                              className="tp-header-top-info-single-content font-medium text-white"
                            >
                              {contacts.tel}
                            </a>
                            <a
                              href={`tel:${contacts.tel2.replaceAll(" ", "")}`}
                              className="tp-header-top-info-single-content font-medium text-white"
                            >
                              {contacts.tel2}
                            </a>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="tp-header-top-info-single">
                      <div className="tp-header-top-info-single-icon mr-15">
                        <i className="flaticon-email"></i>
                      </div>
                      <div className="tp-header-top-info-single-text">
                        <span className="tp-header-top-info-single-label">
                          {t("Navigation.Email")}
                        </span>
                        <a
                          href={`mailto:${contacts.email}`}
                          className="tp-header-top-info-single-content font-medium text-white"
                        >
                          {contacts.email}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-3 col-xl-4 header-logo-wrap">
                  <div className="header-logo">
                    <Link to="/">
                      <img src={logoDark} alt="logo" />
                    </Link>
                  </div>
                </div>
                <div className="col-xxl-4 col-xl-4">
                  <div className="nav-btn_wrapper tp-header-top-info justify-content-end">
                    <div className="tp-header-top-info-single">
                      <div className="tp-header-top-info-single-btn">
                        <Link to="/quote" className="yellow-btn">
                          <i className="flaticon-enter"></i>
                          {t("Navigation.Quote")}
                        </Link>
                      </div>
                    </div>
                    <div className="tp-header-top-info-single">
                      <div className="tp-header-top-info-single-btn">
                        <LanguageSwitcher size={2} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={
              sticky
                ? "nav-height_size sticky-menu tp-header-menu-area tp-transparent-header-menu header-sticky"
                : `none tp-header-menu-area tp-transparent-header-menu header-sticky`
            }
          >
            <div className="container">
              <div className="row justify-content-xl-center align-items-center">
                <div className="col-xl-2 col-6 tp-sticky-column">
                  <div className="tp-sticky-logo">
                    <Link to="/">
                      <img
                        src={logo}
                        className="img-fluid"
                        style={{ height: "80px" }}
                        alt="logo"
                      />
                    </Link>
                  </div>
                </div>
                <div className="col-xl-7 col-6">
                  <div className="tp-main-menu-bg">
                    <div className="nav-items_wrap">
                      <nav id="tp-mobile-menu">
                        <ul className="text-center nav-items">
                          <li>
                            <NavLink
                              to="/"
                              onClick={() => scrollToSection("home")}
                            >
                              {t("Navigation.Home")}
                            </NavLink>
                            {/* Home */}
                          </li>
                          <li>
                            <NavLink
                              to="#"
                              onClick={() => scrollToSection("services")}
                            >
                              {t("Navigation.Services")}
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              to="#"
                              onClick={() => scrollToSection("hireUs")}
                            >
                              {t("Navigation.Why")}
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              to="#"
                              onClick={() => scrollToSection("whoWeAre")}
                            >
                              {t("Navigation.Who")}
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              to="#"
                              onClick={() => scrollToSection("contacts")}
                            >
                              {t("Navigation.Contact")}
                            </NavLink>
                          </li>
                        </ul>
                      </nav>
                    </div>

                    <div className="side-menu-icon d-xl-none text-end">
                      <LanguageSwitcher size={0} />
                      <button
                        onClick={handleShow}
                        className="side-toggle border-0 bg-transparent"
                      >
                        <i>
                          {" "}
                          <FaBars className="bar_icon" />{" "}
                        </i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 tp-sticky-column-btn">
                  <div className="tp-sticky-btn text-end">
                    <div className="tp-header-top-info-single">
                      <div className="tp-header-top-info-single-btn">
                        <Link to="/quote" className="nav-btn">
                          <i className="flaticon-enter"></i>
                          {t("Navigation.QuoteLast")}
                        </Link>
                      </div>
                    </div>
                  </div>
                  <LanguageSwitcher size={0} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <Sidebar show={show} handleClose={handleClose}></Sidebar>

      <Outlet />
    </>
  );
};

export default Navigation;
